import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getDecisionMakerProfilePageData } from './api';
import type { DecisionMakerProfilePageDataLoadErrorCode } from './types';

export const {
	Context: DecisionMakerProfilePageDataContext,
	Provider: DecisionMakerProfilePageDataContextProvider,
	useContext: useDecisionMakerProfilePageData,
	useAsyncData: useDecisionMakerProfilePageDataFromApi,
	prefetchAsyncData: prefetchDecisionMakerProfilePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'DecisionMakerProfilePageDataContext',
	dataProperty: 'pageData',
	getData: getDecisionMakerProfilePageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<DecisionMakerProfilePageDataLoadErrorCode>(),
});
